module.exports = __webpack_public_path__ + "static/media/lebenslauf.065d13e6.pdf";